import { getValueFromString } from 'shared/lib/formatting';

export type BidRangeFormType = {
  bid?: string;
  bidTiers?: { bid: string; id: number }[];
};

type BidRangeData =
  | { bid: number }
  | {
      bidTiers: {
        id: number;
        bid: number;
      }[];
    };

export function getBidRangeData({ bid, bidTiers }: BidRangeFormType): BidRangeData {
  if (bid) {
    return {
      bid: getValueFromString(bid),
    };
  }

  if (bidTiers?.length) {
    return {
      bidTiers: bidTiers.map(({ bid, id }) => ({
        bid: getValueFromString(bid),
        id,
      })),
    };
  }
  throw new Error('Invalid bid or bidTiers data. Please provide a valid bid or bidTiers array.');
}
